import { render } from "./SettingsSideNav.vue.js?vue&type=template&id=70eb1755!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SettingsSideNav.vue?vue&type=template&id=70eb1755"
import script from "./SettingsSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SettingsSideNav.vue?vue&type=script&lang=js"
export * from "./SettingsSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SettingsSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/side-nav/SettingsSideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70eb1755"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70eb1755', __exports__)) {
    api.reload('70eb1755', __exports__)
  }
  
  module.hot.accept("./SettingsSideNav.vue.js?vue&type=template&id=70eb1755!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SettingsSideNav.vue?vue&type=template&id=70eb1755", () => {
    api.rerender('70eb1755', render)
  })

}


export default __exports__